import React from 'react';
import Button from '@mui/material/Button';
import { getFormattedDate, getRoomLabelText, formatPrintAmount } from '@src/utilities/common';
import PrintIcon from '@mui/icons-material/Print';
import DownloadIcon from '@mui/icons-material/Download';
// import jsPDF from 'jspdf';
// import { getApp } from "firebase/app";
// import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import './Print.scss';
import './PrintPDF.scss';
// import { stringify } from 'querystring';
import SampleImage from '@assets/images/sample.png';
import {printPDF, downloadPDF} from './PrintUtility';

declare global {
    interface Window {
        ReactNativeWebView: any;
    }
}
// interface componentRef {
//     current: any
// }

export const getRoomPdfHTMLString = async (item: any, restaurant: any) => {
    var roomsList = "";
    var foodTotalCost = 0;
    // var logo = await toDataURL(restaurant?.logo || SampleImage);
    // var sign = await toDataURL(restaurant?.managerSign || SampleImage);
    var logo = restaurant?.logo || SampleImage;
    var sign = restaurant?.managerSign || SampleImage;
    const gstHalfRate = formatPrintAmount(Number(item?.gstRate ?? item?.restaurant?.roomGST) / 2);
    const gstHalfAmount = formatPrintAmount(Number(item?.gstBill) / 2);
    // !!(item?.cart) && Object.entries(item?.cart).filter((val) => val[1]).forEach(([keyCart, itemCart]: any) => {
    //     sum += !!itemCart?.name && `<tr>
    //         <td style="text-align: left;">
    //             ${(itemCart?.name)?.replaceAll("-"," ")} (${(itemCart?.selectedVariants?.label)?.replaceAll('₹','')})
    //         </td>
    //         <td style="width: 30px; text-align: right;">
    //             x ${itemCart?.selected}
    //         </td>
    //         <td style="width: 30px; text-align: right;">
    //             ${itemCart?.selectedVariants?.value * itemCart?.selected}
    //         </td>
    //     </tr>` || ''
    // });
    (!!(item?.rooms) && item?.rooms)?.forEach((room: any) => {
        roomsList += (!!room && `<tr>
        <td style="border: 1px solid #dcdcdc; text-align: left;">${room?.roomType} -> ${getRoomLabelText(room?.roomNumber?.split("-")[0], parseInt(room?.roomNumber?.split("-")[1]))}</td>
        <td style="border: 1px solid #dcdcdc; text-align: center;">${item?.restaurant?.roomSAC || '996311'}</td>
        <td style="border: 1px solid #dcdcdc; text-align: center;">${room?.noOfNights}</td>
        <td style="border: 1px solid #dcdcdc; text-align: right;">Rs. ${room?.roomCustomCost}</td>
        <td style="border: 1px solid #dcdcdc; text-align: right;">Rs. ${+(room?.roomCustomCost) * room?.noOfNights}</td>
    </tr>`) || ''
    });

    return `
        <style>
            p {margin: 0}
        </style>
        <section>
            <div>
            <table width="100%" style="background-color: #ecedff; -webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 10px 20px; border-radius: 4px;">
                <tbody>
                    <tr>
                        <td width="50%" style="vertical-align: middle;">
                            <img src=${logo} alt="${item?.restaurant?.name}" width="300" />
                        </td>
                        <td align="right" width="50%" style="vertical-align: middle;">
                            <p style="font-size: 30px"><b>Invoice</b></p>
                            <p style="margin-top: 6px"><b>Invoice No.:</b> #${item?.orderSeqNo || item?.uoId || item?.orderId}</p>
                            <p style="margin-top: 3px"><b>Check in date:</b> ${getFormattedDate(item?.checkInDate)}</p>
                            <p style="margin-top: 3px"><b>Check out date:</b> ${getFormattedDate(item?.checkOutDate)}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- invoice head -->
            <div>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td width="45%" valign="top">
                                <p style="font-weight: 500; margin-bottom: 10px;"><b>Bill From:</b></p>
                                
                                <p style="margin-bottom: 6px;">${item?.restaurant?.name}</p>

                                <p style="font-size: 12px; margin-bottom: 2px; font-weight: 600">Address:</p>
                                <p style="margin-bottom: 6px;">${item?.restaurant?.address}</p>
                                    
                                <p style="font-size: 12px; margin-bottom: 2px;"><b>Phone No.:</b> ${restaurant?.phone}</p>
                                <p style="margin-bottom: 6px;"> </p>
                                    
                                <p style="font-size: 12px;margin-bottom: 2px;"><b>GST No.:</b> ${item?.restaurant?.gstIn}</p>
                                    
                            </td>
                            <td></td>
                            <td width="45%" valign="top">
                                <p style="font-weight: 500; margin-bottom: 10px;"><b>Bill To:</b></p>

                                <p style="margin-bottom: 6px;">${item?.guestName}${item?.guestOther ? ', ' + item.guestOther : ''}</p>
                                
                                <p style="font-size: 12px; margin-bottom: 2px;"><b>Company Name:</b> ${item?.guestCompanyName || 'NA'}</p>

                                <p style="font-size: 12px; margin-bottom: 2px;"><b>Address:</b> ${item?.guestAddress || 'NA'}</p>
                                    
                                <p style="font-size: 12px;margin-bottom: 2px;"><b>GST No.:</b> ${item?.guestCompanyGST || 'NA'}</p>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- invoice body-->
            <div>
                <table width="100%; border-spacing: 0px;">
                <thead>
                    <tr>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 5px; text-align: left; font-size: 12px; border: 1px solid #dcdcdc;"><b>ROOM TYPE / ROOM NO.</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 5px; text-align: center; font-size: 12px; border: 1px solid #dcdcdc;"><b>HSN/SAC CODE</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 5px; text-align: center; font-size: 12px; border: 1px solid #dcdcdc;"><b>NIGHT</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 5px; text-align: right; font-size: 12px; border: 1px solid #dcdcdc;"><b>RATE PER NIGHT (₹)</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 5px; text-align: right; font-size: 12px; border: 1px solid #dcdcdc;"><b>AMOUNT (₹)</b></th>
                    </tr>
                </thead>
                <tbody>
                    ${roomsList}
                    <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                </tbody>
                </table>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="50%">
                                &nbsp;
                            </td>
                            <td align="right" width="50%">
                                <table width="350px" style="border-spacing: 0;">
                                    <tbody>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0; font-weight: 500;">Room Charges</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px;">Rs. ${formatPrintAmount(item?.itemsCost)}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0 5px; font-weight: 500;">Less: Discount</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px 5px;">Rs. ${formatPrintAmount(item?.discount)}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0 0; font-weight: 500;"><b>Taxable Value</b></td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px 0;">Rs. ${formatPrintAmount(item?.itemsCost - item?.discount)}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0; font-weight: 500;">CGST @ (${gstHalfRate}%)</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px;">Rs. ${gstHalfAmount}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0; font-weight: 500;">SGST @ (${gstHalfRate}%)</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px;">Rs. ${gstHalfAmount}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 15px 0; font-weight: 500; border-top: 1px solid #ddd; font-weight: 600;">Invoice Total</td>
                                            <td style="text-align: right; font-size: 14px; padding: 15px 10px; border-top: 1px solid #ddd; font-weight: 600;">Rs. ${formatPrintAmount(item?.totalCost || 0)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <table width="100%">
                <tbody>
                    <tr>
                        <td align="right" style="font-size: 20px;">
                            <b>Total Amout to Be Paid Rs. ${formatPrintAmount(foodTotalCost + Number(item?.totalCost))} /-</b>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- invoice footer -->
            <div>
                <p>Thank you for your business!</p>
                <p style="margin: 10px 0">-</p>
                <p style="margin-bottom: 50px">Regardless of the billing instruction I agree to be held personally liable for payment of the total amount of this bill.</p>
                <table width="100%" style="margin-bottom: 10px">
                    <tbody>
                        <tr>
                            <td width="50%">
                                <p>
                                    <b>Manager Sign</b>
                                </p>
                            </td>
                            <td width="50%">
                                <p><b>Guest Sign</b></p>
                            </td>
                        </tr>
                        <tr>
                            <td width="50%">
                                <p>
                                    <img width="150" height="70" src=${sign} title="manager sign" />
                                </p>
                            </td>
                            <td width="50%">
                                &nbsp;
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <table width="100%" style="-webkit-print-color-adjust: exact; print-color-adjust: exact; background-color: #ecedff; padding: 0 10px;">
                <tbody>
                    <tr>
                        <td align="center" width="50%" style="vertical-align: middle;">
                            <p><b>Thanks for Choosing - ${item?.restaurant?.name}</b></p>
                        </td>
                    </tr>
                    <tr>
                        <td align="center" width="50%" style="vertical-align: middle;">
                            <p>Note: You are not authorized to upload this format to any online / offline medium without the permission of ${item?.restaurant?.name}©</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </section>
    `;
}

// const toDataURL = async (url: string) => {
//     try {
//         const response = await fetch(url);
//         const blob = await response.blob();

//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result);
//             reader.onerror = reject;
//             reader.readAsDataURL(blob);
//         });
//     } catch (error) {
//         console.error("Error converting image to Base64:", error);
//         return null; // Return null if fetch fails
//     }
// };

export const getRoomPdfHTMLStrings = async (item: any, restaurant: any) => {
    var roomsList = "";
    // var logo = await toDataURL(restaurant?.logo || SampleImage);
    // var sign = await toDataURL(restaurant?.managerSign || SampleImage);
    var logo = restaurant?.logo || SampleImage;
    var sign = restaurant?.managerSign || SampleImage;
    const gstHalfRate = formatPrintAmount(Number(item?.gstRate ?? item?.restaurant?.roomGST) / 2);
    const gstHalfAmount = formatPrintAmount(Number(item?.gstBill) / 2);

    // !!(item?.cart) && Object.entries(item?.cart).filter((val) => val[1]).forEach(([keyCart, itemCart]: any) => {
    //     sum += !!itemCart?.name && `<tr>
    //         <td style="text-align: left;">
    //             ${(itemCart?.name)?.replaceAll("-"," ")} (${(itemCart?.selectedVariants?.label)?.replaceAll('₹','')})
    //         </td>
    //         <td style="width: 30px; text-align: right;">
    //             x ${itemCart?.selected}
    //         </td>
    //         <td style="width: 30px; text-align: right;">
    //             ${itemCart?.selectedVariants?.value * itemCart?.selected}
    //         </td>
    //     </tr>` || ''
    // });
    (!!(item?.rooms) && item?.rooms)?.forEach((room: any) => {
        roomsList += (!!room && `<tr>
        <td style="padding: 10px; font-size: 14px; text-align: left;">${room?.roomType} -> ${getRoomLabelText(room?.roomNumber?.split("-")[0], parseInt(room?.roomNumber?.split("-")[1]))}</td>
        <td style="padding: 10px; font-size: 14px; text-align: center;">${item?.restaurant?.roomSAC || '996311'}</td>
        <td style="padding: 10px; font-size: 14px; text-align: center;">${room?.noOfNights}</td>
        <td style="padding: 10px; font-size: 14px; text-align: right;">Rs. ${room?.roomCustomCost}</td>
        <td style="padding: 10px; font-size: 14px; text-align: right;">Rs. ${+(room?.roomCustomCost) * room?.noOfNights}</td>
    </tr>`) || ''
    });

    return `
        <style>
            p {margin: 0; font-size: 14px; font-family: system-ui;} b {font-weight: 600;}
        </style>
        <section>
            <div>
            <table width="100%" style="background-color: #ecedff; -webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 10px 20px; border-radius: 4px;">
                <tbody>
                    <tr>
                        <td width="50%" style="vertical-align: middle;">
                            <img src=${logo} alt="${item?.restaurant?.name}" width="300" />
                        </td>
                        <td align="right" width="50%" style="vertical-align: middle;">
                            <p style="font-size: 30px"><b>Invoice</b></p>
                            <p style="margin-top: 6px"><b>Invoice No.:</b> #${item?.orderSeqNo || item?.uoId || item?.orderId}</p>
                            <p style="margin-top: 3px"><b>Check in date:</b> ${getFormattedDate(item?.checkInDate)}</p>
                            <p style="margin-top: 3px"><b>Check out date:</b> ${getFormattedDate(item?.checkOutDate)}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- invoice head -->
            <div>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td width="45%" valign="top">
                                <p style="font-weight: 500; margin-bottom: 10px;">Bill From:</p>
                                
                                <p style="margin-bottom: 6px;">${item?.restaurant?.name}</p>

                                <p style="font-size: 12px; margin-bottom: 2px; font-weight: 600">Address:</p>
                                <p style="margin-bottom: 6px;">${item?.restaurant?.address}</p>
                                    
                                <p style="font-size: 12px; margin-bottom: 2px;"><b>Phone No.:</b> ${restaurant?.phone}</p>
                                <p style="margin-bottom: 6px;"> </p>
                                    
                                <p style="font-size: 12px;margin-bottom: 2px;"><b>GST No.:</b> ${item?.restaurant?.gstIn}</p>
                                    
                            </td>
                            <td></td>
                            <td width="45%" valign="top">
                                <p style="font-weight: 500; margin-bottom: 10px;">Bill To:</p>

                                <p style="margin-bottom: 6px;">${item?.guestName}${item?.guestOther ? ', ' + item.guestOther : ''}</p>
                                
                                <p style="font-size: 12px; margin-bottom: 2px;"><b>Company Name:</b> ${item?.guestCompanyName || 'NA'}</p>

                                <p style="font-size: 12px; margin-bottom: 2px;"><b>Address:</b> ${item?.guestAddress || 'NA'}</p>
                                    
                                <p style="font-size: 12px;margin-bottom: 2px;"><b>GST No.:</b> ${item?.guestCompanyGST || 'NA'}</p>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- invoice body-->
            <div>
                <table style="border-collapse: collapse; border: 0; border-bottom: 1px solid #ddd;" width="100%;">
                <thead>
                    <tr style="border-top: 1px solid #ddd;    border-bottom: 1px solid #ddd;">
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 15px 10px; text-align: left; font-size: 12px"><b>ROOM TYPE / ROOM NO.</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 15px 10px; text-align: center; font-size: 12px"><b>HSN/SAC CODE</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 15px 10px; text-align: center; font-size: 12px"><b>NIGHT</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 15px 10px; text-align: right; font-size: 12px"><b>RATE PER NIGHT (₹)</b></th>
                        <th style="-webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 15px 10px; text-align: right; font-size: 12px"><b>AMOUNT (₹)</b></th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    ${roomsList}
                    <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                </tbody>
                </table>
                <table width="100%" style="margin-top: 30px;">
                    <tbody>
                        <tr>
                            <td width="50%">
                                &nbsp;
                            </td>
                            <td align="right" width="50%">
                                <table width="350px" style="border-spacing: 0;">
                                    <tbody>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0; font-weight: 500;">Room Charges</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px;">Rs. ${formatPrintAmount(item?.itemsCost)}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0 15px; font-weight: 500;">Less: Discount</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px 15px;">Rs. ${formatPrintAmount(item?.discount)}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0 15px; font-weight: 500;"><b>Taxable Value</b></td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px 15px;">Rs. ${formatPrintAmount(item?.itemsCost - item?.discount)}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0; font-weight: 500;">CGST @ (${gstHalfRate}%)</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px;">Rs. ${gstHalfAmount}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 5px 0; font-weight: 500;">SGST @ (${gstHalfRate}%)</td>
                                            <td style="text-align: right; font-size: 14px; padding: 5px 10px;">Rs. ${gstHalfAmount}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px; padding: 15px 0; font-weight: 500; border-top: 1px solid #ddd; font-weight: 600;">Invoice Total</td>
                                            <td style="text-align: right; font-size: 14px; padding: 15px 10px; border-top: 1px solid #ddd; font-weight: 600;">Rs. ${formatPrintAmount(item?.totalCost || 0)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- invoice footer -->
            <div style="margin-top: 40px">
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="50%">
                                &nbsp;
                            </td>
                            <td width="50%">
                                <p style="text-align: right">
                                    <img width="150" src=${sign} title="manager sign" />
                                </p>
                            </td>
                        </tr>
                                                <tr>
                            <td width="50%">
                                &nbsp;
                            </td>
                            <td width="50%">
                                <p style="text-align: right"><b>Authorized Signatory</b></p>
                                <p style="text-align: right; font-size: 12px; margin-top: 4px;">Digitally Signed by ${item?.restaurant?.name}</p>
                                <p style="text-align: right; font-size: 12px">Date: ${getFormattedDate(item?.checkOutDate)}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <table width="100%" style="-webkit-print-color-adjust: exact; print-color-adjust: exact; background-color: #ecedff; padding: 10px 20px; border-radius: 4px; margin-top: 20px;">
                <tbody>
                    <tr>
                        <td align="center" width="50%" style="vertical-align: middle;">
                            <p><b>Thanks for Choosing - ${item?.restaurant?.name}</b></p>
                        </td>
                    </tr>
                    <tr>
                        <td align="center" width="50%" style="vertical-align: middle;">
                            <p style="font-size: 12px; margin-top: 5px;">Note: You are not authorized to upload this format to any online / offline medium without the permission of ${item?.restaurant?.name}©</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div>
                
                
            </div>
            </div>
        </section>
    `;
}


function PrintRoomPDF({ item, restaurant }: any) {
    // const componentRef: componentRef = useRef(null);
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef?.current,
    // });

    // const sendMessageToWebView = (urlPdf: any) => {
    //     const data = {"type": "print", "data": urlPdf || "<p>Error...Error...</p>"};
    //     // console.log(data, componentRef?.current?.innerHTML);
    //     if(window?.ReactNativeWebView){
    //         // const data = 'Hello from React!';
    //         window.ReactNativeWebView?.postMessage(JSON.stringify(data) || "");
    //     } else {
    //         handlePrint();
    //     }
    // };

    // const printOnNative = (item: any) => {
    //     const htmlString = getHTMLString(item);
    //     sendMessageToWebView(htmlString);
    // }

    const handleGeneratePdf = async (e: any, isDownload:boolean = false) => {
        e?.stopPropagation();
        const htmlContent = restaurant.esign ? await getRoomPdfHTMLStrings(item, restaurant): await getRoomPdfHTMLString(item, restaurant);
        // console.log(htmlContent);
        if(isDownload){
            await downloadPDF(htmlContent, item?.uoId || item?.orderId);
        } else {
            await printPDF(htmlContent, item?.uoId || item?.orderId);
        }

        // if(window?.ReactNativeWebView){
        //     printOnNative(item);
        // } else {
        //     handlePrint();
        // }
    };

    return (
        <>
            <Button color='secondary' className='printBtn' onClick={(e: any) => handleGeneratePdf(e)}><PrintIcon /> PDF</Button>
            <Button color='secondary' className='printBtn' onClick={(e: any) => handleGeneratePdf(e, true)}><DownloadIcon /></Button>
        </>
    );
}

export default PrintRoomPDF;
